import { useEffect, useState } from 'react';
import {
  getAnalyticsConsent,
  setAnalyticsConsent,
} from '../../../utils/analytics';
import './CookieConsentBanner.css';

/**
 * GDPR / ePrivacy consent banner.
 *
 * Until a visitor explicitly accepts or declines, the visible banner
 * lets them choose. analytics.js stores the decision in localStorage
 * for 6 months and gates trackEvent() accordingly.
 *
 * Intentionally minimal: two buttons, no settings panel. Marketing
 * copy uses the calmest possible framing because the site is already
 * cookieless beyond identifiers — declining only suppresses analytics,
 * the rest of the site keeps working.
 */
const CookieConsentBanner = () => {
  const [decision, setDecision] = useState('unknown');
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setDecision(getAnalyticsConsent());
    setMounted(true);
  }, []);

  if (!mounted) return null;
  if (decision === 'granted' || decision === 'denied') return null;

  return (
    <>
      <div className="emblem-consent-banner__scrim" aria-hidden="true" />
      <div
        className="emblem-consent-banner"
        role="dialog"
        aria-modal="true"
        aria-label="Cookie consent"
      >
        <div className="emblem-consent-banner__copy">
          <strong>Analytics cookies</strong>
          <span>
            We use a small first-party identifier to count visits and
            measure how Emblem is used. No ads, no profiling, no
            third-party trackers.{' '}
            <a href="/privacy" className="emblem-consent-banner__link">
              Read our privacy policy
            </a>
            .
          </span>
        </div>
        <div className="emblem-consent-banner__actions">
          <button
            type="button"
            className="emblem-consent-banner__decline"
            onClick={() => {
              setAnalyticsConsent('denied');
              setDecision('denied');
            }}
          >
            Decline
          </button>
          <button
            type="button"
            className="emblem-consent-banner__accept"
            onClick={() => {
              setAnalyticsConsent('granted');
              setDecision('granted');
            }}
          >
            Accept
          </button>
        </div>
      </div>
    </>
  );
};

export default CookieConsentBanner;
